import React, { useMemo } from 'react';
import styled from 'styled-components';
import QuantitySelector from '../molecules/QuantitySelector';
import { formatCurrency } from '../../../utils';
import { SOFT_TOMATO } from '../../colors';
import { CartItemName } from '../../typography';

interface CartItemInterface {
  thumbnail: string;
  name: string;
  amount: string;
  units: {
    type: string;
    price: string;
    quantity?: string | number;
  }[];
  onRemove: () => void;
  onIncrease: (unitType: string) => void;
  onDecrease: (unitType: string) => void;
}

const CartItem = ({
  thumbnail,
  name,
  amount,
  units,
  onIncrease,
  onDecrease,
  onRemove,
}: CartItemInterface) => {

  const totalAmount = useMemo(() => {
    let amount = 0;
    units.forEach((unit) => {
      if (Number(unit.quantity) > 0) {
        amount += (Number(unit.quantity) * Number(unit.price));
      }
    })
    return amount;
  }, [units])

  return (
    <>
      <Container> 
        <Thumbnail>
          <img 
            src={thumbnail} 
          />
        </Thumbnail>

        <Content>
          <CartItemName> 
            {name.toUpperCase()}
          </CartItemName>
          {units.map((unit) => {
            if (unit.quantity) {
              return (
                <Unit>
                  <p>
                    {unit.type} - {formatCurrency(unit.price)}
                  </p>
                  <QuantitySelector 
                    quantity={Number(unit.quantity)} 
                    onDecrease={() => onDecrease(
                      unit.type
                    )} 
                    onIncrease={() => onIncrease(
                      unit.type
                    )} 
                  />
                </Unit>
              )
            } else {
              return null;
            }
          })}
        </Content>

        <Checkout>
          <p> 
            {formatCurrency(totalAmount)}
          </p>
          <button
            onClick={() => onRemove()}
          > 
            REMOVE
          </button>
        </Checkout>
        
      </Container>
    </>
  )
}

export default CartItem;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0rem;
  border-bottom: 1px solid ${SOFT_TOMATO};
`;

const Thumbnail = styled.div`
  height: 80px;
  
  img {
    height: inherit;
    object-fit: cover;
  }
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0rem 0.5rem;
`;

const Unit = styled.div`
  display: flex;

  p {
    margin: 0 0;
    flex: 1;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
  }
`;


const Checkout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    flex: 1;
    flex-direction: row;
    margin: 0 0;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
  }

  button {
    height: 20px;
    background: transparent;
    border: none;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    
    color: ${SOFT_TOMATO}
  }
`;

const styles: {[key: string]: React.CSSProperties} = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0rem',
    borderBottom: '1px solid #E5605E'
  },
  thumbnail: {
    // border: '1px solid red',
    height: 100,
  },
  thumbnailImg: {
    width: '100%',
    height: 'inherit',
    objectFit: 'cover',
  },
  content: {
    // border: '1px solid red',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '0rem 0.5rem'
  },
  contentTitle: {
    margin: '0 0',
    fontFamily: 'Poppins-Medium',
    fontSize: `0.8rem`,
    lineHeight: `0.8rem`,
  },
  contentItem: {
    margin: '0 0',
    flex: 1,
    fontFamily: 'Poppins-Medium',
    fontSize: `0.8rem`,
  },
  amount: {
    // border: '1px solid red',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  amountTitle: {
    margin: '0 0',
    fontFamily: 'Poppins-SemiBold',
    fontSize: `0.8rem`,
    lineHeight: `0.8rem`,
  }
}